import {NgModule} from '@angular/core';
import {CommonModule, NgClass, NgStyle} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {RouterLink} from '@angular/router';
import {UiBasicModule} from './ui/components/basic/ui-basic.module';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgClass,
        NgStyle,
        NgSelectModule,
        UiBasicModule,
        RouterLink
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        NgClass,
        NgStyle,
        NgSelectModule,
        UiBasicModule,
        RouterLink
    ]
})
export class SharedUtilsModule {
}
